/** @jsx jsx */

import { jsx } from '@emotion/core';

import { Icon } from '@zapier/zinnia-icons';
import { Colors, Grid, Text } from '@zapier/design-system';

import LinkWithArrow from 'app/developer-v3/components/LinkWithArrow';
import {
  TABS as SIDEBAR_RIGHT_TABS,
  VERSIONING_SECTION_IDS,
  useSidebarRight,
} from 'app/developer-v3/components/SidebarRight';

import Styles from '../CTAVersioning.styles';

type Props = {
  version: string;
};

function Progress(props: Props) {
  const { version } = props;

  const { update: updateSidebarRight } = useSidebarRight();

  return (
    <div css={Styles.root(Colors.Blue1)}>
      <Grid columns="24px auto" gap={20}>
        <Icon color="Blue3" name="miscUptime" size={24} />
        <div>
          <Text fontWeight={600} tag="h2" type="Body4">
            Promoting integration version
          </Text>
          <Text margin="10px 0px 0px" tag="p">
            We’re promoting your integration version {version}. View the
            progress in the{' '}
            <LinkWithArrow
              onClick={() =>
                updateSidebarRight({
                  tabActive: SIDEBAR_RIGHT_TABS.VERSIONING,
                  activeSubsection: VERSIONING_SECTION_IDS.PROMOTE,
                })
              }
            >
              side panel
            </LinkWithArrow>
            .
          </Text>
        </div>
      </Grid>
    </div>
  );
}

export default Progress;
